<template>
	<SOSlotModal
		:modal-title="'Ekspor'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="f-regular f-16 f-c-black">
				{{ exportDataLength }} File belum didownload. Apakah anda yakin ingin melanjutkan & menghapus file
				tersebut?
			</div>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Oke, mengerti'"
				:outline="true"
				:full="true"
				@action="dismissExport"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOModalConfirmDeleteExport",
	components: {
		SOSlotModal,
		SOButton,
	},
	props: {
		exportDataLength: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			id: "modal-delete-export"
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		dismissExport() {
			this.$emit("dismiss-export")
		}
	}
}
</script>